import { partnerServices } from "../../config/axios";
import MyVouchers from "../../views/Vouchers/MyVouchers/MyVouchers";
import {
  ADD_MANUAL_AMOUNT_SUCCESS,
  ADD_MANUAL_AMOUNT_FAILED,
  RESET_ADD_MANUAL_AMOUNT,
  LOADING_ADD_MANUAL_AMOUNT,
  NETWORK_ERROR_ADD_MANUAL_AMOUNT,
} from "../types";

function resetAddManualAmountDetails() {
  return {
    type: RESET_ADD_MANUAL_AMOUNT,
  };
}

const getAddManualAmountDetails = (data, authTokenIs) => async (dispatch) => {
  dispatch({
    type: LOADING_ADD_MANUAL_AMOUNT,
  });

  await partnerServices
    .post("addManualAmount", data, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getAddManualAmountDetailsSuccess(res.data));
          break;
        default:
          dispatch(getAddManualAmountDetailsFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_ADD_MANUAL_AMOUNT, payload: err });
    });
};
function getAddManualAmountDetailsFailed(data) {
  return {
    type: ADD_MANUAL_AMOUNT_FAILED,
    payload: data,
  };
}
function getAddManualAmountDetailsSuccess(data) {
  return {
    type: ADD_MANUAL_AMOUNT_SUCCESS,
    payload: data,
  };
}

export { getAddManualAmountDetails, resetAddManualAmountDetails };
